import React, { useEffect, useState } from 'react';
import { Pagination } from '../../../components';
import GoBackButton from '../../../components/GoBackButton';
import axiosInstance from '../../../services/AxiosInstance';

function Companytransactions() {

	const [data, setData] = useState([]);

	useEffect(() => {
		getData();
	}, []);

	const getData = (page = 1) => {
		axiosInstance(`payments/?fields=id,date,amt,paymentSymbol,date_time&page=${page}`, { method: "GET" })
			.then(res => setData(res?.data))
	}

	return (
		<div className="job-bx table-job-bx clearfix">
			<div className="job-bx-title clearfix">
				<h5 className="font-weight-700 pull-left text-uppercase">Transaction History</h5>
				<GoBackButton />
			</div>
			<table>
				<thead>
					<tr>
						<th>S.No</th>
						<th>Job</th>
						<th>Amount</th>
						<th>Date</th>
						<th>Payment Method</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					{
						data?.results?.map((tr, i) => {
							var id = +`${data?.pagination?.currentPage - 1}0`
							return (
								<tr key={tr.id}>
									<td className="order-id text-primary">{id + i + 1}</td>
									<td className="job-name">{tr?.job}</td>
									<td className="amount text-primary">{tr?.paymentSymbol} {tr?.amt}</td>
									<td className="date">{tr?.date_time}</td>
									<td className="transfer">{tr?.pay_method}</td>
									<td className={`expired ${tr?.status === "Success" ? "success" : "pending"}`}>{tr?.status} </td>
								</tr>
							)
						})
					}
				</tbody>
			</table>
			{data?.length > 0 &&
				<div className="pagination-bx float-right">
					<Pagination
						data={data}
						getData={getData}
					/>
				</div>
			}
		</div>
	)
}
export default Companytransactions;